import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Empty } from "./AdminLeads";
import { toast } from "sonner";
import { Trash2, Mail } from "lucide-react";

export function AdminQueries() {
  const qc = useQueryClient();
  const { data: queries = [], isLoading } = useQuery({ queryKey: ["admin-queries"], queryFn: () => api.get("/queries").then((r) => r.data) });

  const remove = async (id) => {
    await api.delete(`/queries/${id}`);
    qc.invalidateQueries({ queryKey: ["admin-queries"] });
    toast.success("Query deleted");
  };

  if (isLoading) return <p className="font-mono text-sm text-muted-foreground">Loading…</p>;
  if (!queries.length) return <Empty label="No queries received yet." />;

  return (
    <div className="grid gap-px border border-border bg-border md:grid-cols-2" data-testid="admin-queries">
      {queries.map((q) => (
        <div key={q.id} className="flex flex-col bg-background p-6" data-testid={`query-card-${q.id}`}>
          <div className="flex items-start justify-between">
            <div>
              <h4 className="font-display text-lg font-bold uppercase text-foreground">{q.name}</h4>
              <a href={`mailto:${q.email}`} className="flex items-center gap-2 font-mono text-xs text-cyan"><Mail className="h-3 w-3" />{q.email}</a>
              {q.phone && <p className="font-mono text-xs text-muted-foreground">{q.phone}</p>}
            </div>
            <Button size="icon" variant="ghost" onClick={() => remove(q.id)} data-testid={`query-delete-${q.id}`} className="text-muted-foreground hover:text-destructive">
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>
          <p className="mt-4 flex-1 text-sm text-muted-foreground">{q.message}</p>
          <p className="mt-4 font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{new Date(q.created_at).toLocaleString("en-IN")}</p>
        </div>
      ))}
    </div>
  );
}
